import "./banners.css";
import banner1 from '../../../../assets/imgs/banners-home/banner1.png';
import banner2 from '../../../../assets/imgs/banners-home/banner2.png';
import banner3 from '../../../../assets/imgs/banners-home/banner3.jpg';
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Banners() {
  const navigate = useNavigate();
  let currentLng = "es";
  localStorage.getItem("lng") ? currentLng = `${localStorage.getItem("lng")}` : currentLng = 'es';
  const [index, setIndex] = useState(0);
  const slides_es = [
    {
      img: banner2,
      title: "Entrega garantizada",
      desc: "Servicio express en menos de 24 horas.",
      url: "/servicios/internacional/express"
    },
    {
      img: banner3,
      title: "Cobertura nacional",
      desc: "Llegamos a más de 35 destinos nacionales.",
      url: "/estaciones/nacionales"
    },
  ];

  const slides_en = [
    {
      img: banner2,
      title: "Guaranteed delivery",
      desc: "Express service in less than 24 hours.",
      url: "/servicios/internacional/express"
    },
    {
      img: banner3,
      title: "National coverage",
      desc: "We reach more than 35 national destinations.",
      url: "/estaciones/nacionales"
    },
  ];

  const slides = currentLng === 'es' ? slides_es : slides_en;

  const prevSlide = () => {
    setIndex((old) => (old === 0 ? slides.length - 1 : old - 1));
  };

  const nextSlide = () => {
    setIndex((old) => (old === slides.length - 1 ? 0 : old + 1));
  };

  const goToSlide = (i) => {
    setIndex(i);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((old) => (old === slides.length - 1 ? 0 : old + 1));
    }, 10000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const paginationLabel =
    currentLng === "es" ? "Paginación del banner" : "Banner pagination";

  return (
    <div className="slide-container-home">
      <div className="slide-container">
        <button
          type="button"
          className="arrow-left"
          onClick={prevSlide}
          aria-label={currentLng === "es" ? "Slide anterior" : "Previous slide"}
        >
          <FaArrowLeftLong />
        </button>

        <div className="slides-wrapper">
          {slides.map((slide, i) => (
            <div className={`slide ${index === i ? "active" : ""}`} key={i}>
              <img src={slide.img} alt="" aria-hidden="true" />
              <div className="bg-black-slide" />
              <div className="text-container">
                <h2>{slide.title}</h2>
                <p>{slide.desc}</p>
                <button type="button" onClick={() => navigate(slide.url)}>
                  {currentLng === "es" ? "Ver más" : "See more"}
                </button>
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="arrow-right"
          onClick={nextSlide}
          aria-label={currentLng === "es" ? "Slide siguiente" : "Next slide"}
        >
          <FaArrowRightLong />
        </button>
      </div>

      <div
        className="banner-pagination"
        role="tablist"
        aria-label={paginationLabel}
      >
        {slides.map((_, i) => (
          <button
            type="button"
            key={i}
            role="tab"
            className={`banner-pagination__dot ${index === i ? "is-active" : ""}`}
            onClick={() => goToSlide(i)}
            aria-label={
              currentLng === "es"
                ? `Slide ${i + 1} de ${slides.length}`
                : `Slide ${i + 1} of ${slides.length}`
            }
            aria-selected={index === i}
          />
        ))}
      </div>
    </div>
  );
}

export default Banners;
